import {ReduxSlices} from "floorplan-v2/app/appRoot/types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ISettingState } from "./types";
import { IfloorplanSettings } from 'external-services/general-settings-service/types';

const forceBookingCreator = !!window.config?.forceBookingCreator;
const forceBookingCardList = !!window.config?.forceBookingCardList;

const initialState: ISettingState = {
  floorplanSettings: {
    overviewZoom: '0.5',
    showSectionName: true,
    minBookingSlotsAvailability: 60,
    maxBookingSlotsAvailability: 120,
    useBookingCardList: forceBookingCardList,
    enableBookingCreatorOnFloorplan: forceBookingCreator || true,
    enableBookingCreatorOnTimeline: forceBookingCreator,
  },
  floorplanPattern: 'schedule',
  showCustomerNameOnBooking: false, // floorplan-v2 show customer name for booking on the table
  showTimeRemainingOnBooking: false, // floorplan-v2 show time remaining for booking on the table
  isFloorplanInitialized: true,
}

const settingsSlice = createSlice({
  name: ReduxSlices.Settings,
  initialState,
  reducers: {
    setFloorplanSettings: (state: ISettingState, action: PayloadAction<IfloorplanSettings>) => {
      const config = {...action.payload};
      if (forceBookingCreator) {
        config.enableBookingCreatorOnFloorplan = true;
        config.enableBookingCreatorOnTimeline = true;
      }
      if (forceBookingCardList) {
        config.useBookingCardList = true;
      }
      state.floorplanSettings = config;
    },
    setFloorplanPattern: (state: ISettingState, action: PayloadAction<'status' | 'schedule'>) => {
      state.floorplanPattern = action.payload;
    },
    setIsFloorplanInitialized: (state: ISettingState, action: PayloadAction<boolean>) => {
      state.isFloorplanInitialized = action.payload;
    },
    setShowCustomerNameOnBooking: (state: ISettingState, action: PayloadAction<boolean>) => {
      state.showCustomerNameOnBooking = action.payload;
    },
    setShowTimeRemainingOnBooking: (state: ISettingState, action: PayloadAction<boolean>) => {
      state.showTimeRemainingOnBooking = action.payload;
    },
    resetFloorplanSettings: (state: ISettingState) => {
      return initialState;
    }
  }
})

// Extract the action creators object and the reducer
const { actions, reducer } = settingsSlice;
// Extract and export each action creator by name
export {actions as floorplanSettingsActions};
// Export the reducer, either as a default or named export
export default reducer;
